import { getAppHeaderHeight } from '@/shared/lib';

export const WINDOW_EDGE_GAP = 16;

// The app header and a document's sticky toolbar cover the top of the
// window, so a pop-up keeps below both.
export const getPopoverCollisionPadding = () => ({
  top:
    Math.max(
      getAppHeaderHeight(),
      document
        .querySelector('[data-component="workspace-document-toolbar"]')
        ?.getBoundingClientRect().bottom ?? 0,
    ) + WINDOW_EDGE_GAP,
  right: WINDOW_EDGE_GAP,
  bottom: WINDOW_EDGE_GAP,
  left: WINDOW_EDGE_GAP,
});
